import { render, staticRenderFns } from "./FormMetadataChangeResponse.vue?vue&type=template&id=aab78998&scoped=true&lang=pug"
import script from "./FormMetadataChangeResponse.vue?vue&type=script&lang=js"
export * from "./FormMetadataChangeResponse.vue?vue&type=script&lang=js"
import style0 from "./FormMetadataChangeResponse.vue?vue&type=style&index=0&id=aab78998&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab78998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aab78998')) {
      api.createRecord('aab78998', component.options)
    } else {
      api.reload('aab78998', component.options)
    }
    module.hot.accept("./FormMetadataChangeResponse.vue?vue&type=template&id=aab78998&scoped=true&lang=pug", function () {
      api.rerender('aab78998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormMetadataChangeResponse.vue"
export default component.exports